import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useEffect, useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import { WITH_BLIP } from "./PaymentMethod";
import InputText from "../components/Form/InputText";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

export default function PaymentWithBlip() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    // Reset specific fields if the selected compensation is not WITH_BLIP
    useEffect(() => {
        if (formData.paymentmethod === WITH_BLIP) {
            setFormData((prev) => ({
                ...prev,
                cardnumber: "",
                phonenumberapp: "",
            }));
        }
    }, [formData.compensation, setFormData]);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values, { setSubmitting, setErrors }) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/ersattning-for");
                }}
                initialValues={{
                    ...formData,

                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}

                validationSchema={Yup.object().shape({
                    ticketnumber: Yup.string()
                        .required("Vänligen fyll i ditt biljett-ID")
                        .min(7, "Biljett-ID måste innehålla 7 tecken")
                })}

            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"40"} />
                            </div>
                        </div>
                        <Form noValidate>

                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="">Jag blippade mitt bankkort ombord</h2>

                                <p>
                                    För att gå vidare behöver vi biljettens ID. <a href="https://www.ostgotatrafiken.se/biljetter/kopa-biljett/med-betalkort/kvitto-nar-du-blippat-betalkort/#/" target="_blank">Ta reda på biljettens ID här.</a>
                                </p>
                                <p>
                                    Har det gått mer än sju dagar sedan du reste och vill reklamera en
                                    biljett som du betalat genom att blippa ditt betalkort kontaktar du kundservice.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="ticketnumber"
                                    label={
                                        <>
                                            Biljett-ID <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="text"
                                    autocomplete={"off"}
                                    moreinfo="7 tecken"
                                    maxLength={7}
                                />
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
